<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  data() {
    return {
      status: 'IDLE',
    };
  },
  computed: {
    isPending() {
      return this.status === 'PENDING';
    },
  },
  props: {
    disableLoadingIcon: {
      default: false,
      type: Boolean,
    },
    silentSuccess: {
      default: false,
      type: Boolean,
    },
    silentError: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    async submitForResult(requestPromise) {
      this.status = 'PENDING';
      const result = await requestPromise();
      if (result.isOk()) {
        if (!this.silentSuccess) {
          this.$clyNotify({ message: result.value.message, sticky: false, type: 'success' });
        }
        this.$emit('success', result.value);
      } else {
        if (!this.silentError) {
          this.$clyNotify({ message: result.error.message, sticky: false, type: 'error' });
        }
        this.$emit('error', result.error, result);
      }
      this.status = 'IDLE';
      return result;
    },
  },
});
</script>
<template>
  <div v-loading="!disableLoadingIcon && isPending">
    <slot
      :submit="submitForResult"
      :status="status"
      :is-pending="isPending"
    />
  </div>
</template>
